// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  staging: false,
  recatchaEnabled: true,
  recatchaSiteKey: '6LeL9tMUAAAAAOzfuIF3Yq-1byoaUO2jx0vR-vj6',
  api: 'https://api.autotransportalliance.com/api',
  socket_api: 'wss://api.autotransportalliance.com',
  logtashUrl: '',
  apmServiceURL: 'https://apm.autotransportalliance.com',
  addressAutocompleteTelemetryEnabled: true,
};
